'use client';

import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSubscription } from '@/hooks/useSubscription';
import { Button } from '@/components/ui/button';
import { Sparkles, ChevronUp, ChevronDown, Zap } from 'lucide-react';

export function UpgradeBanner() {
  const { isFree, isLoading, createCheckout, isCreatingCheckout } = useSubscription();
  const [minimized, setMinimized] = useState(false);
  const location = useLocation();

  // Hide for advisor routes - advisors don't need upgrade prompts
  const isAdvisorRoute = location.pathname.startsWith('/advisor');

  // Only show for free users, hide while loading, hide for advisors
  if (isLoading || !isFree || isAdvisorRoute) return null;

  if (minimized) {
    return (
      <div
        className="text-white"
        style={{ background: 'linear-gradient(45deg, #124ab7, #102d66)' }}
      >
        <div className="max-w-7xl mx-auto px-4">
          <button
            onClick={() => setMinimized(false)}
            className="w-full py-1.5 flex items-center justify-center gap-2 text-sm font-medium hover:bg-white/10 transition-colors"
          >
            <Sparkles className="h-4 w-4" />
            <span>Upgrade to unlock all features</span>
            <ChevronDown className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="text-white"
      style={{ background: 'linear-gradient(45deg, #124ab7, #102d66)' }}
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <div className="hidden sm:flex h-10 w-10 items-center justify-center rounded-full bg-white/20 flex-shrink-0">
              <Zap className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-sm sm:text-base">
                You're on the Free plan
              </p>
              <p className="text-xs sm:text-sm text-white/90 truncate">
                Upgrade to generate strategies, upload documents & access AI tools
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              size="sm"
              className="bg-white text-[#124ab7] hover:bg-white/90 font-semibold shadow-md"
              onClick={() => createCheckout('core')}
              disabled={isCreatingCheckout}
            >
              <Sparkles className="h-4 w-4 mr-1.5" />
              {isCreatingCheckout ? (
                <span>Loading...</span>
              ) : (
                <>
                  <span className="hidden sm:inline">Upgrade Now</span>
                  <span className="sm:hidden">Upgrade</span>
                </>
              )}
            </Button>
            <button
              onClick={() => setMinimized(true)}
              className="p-1.5 hover:bg-white/10 rounded transition-colors"
              aria-label="Minimize banner"
            >
              <ChevronUp className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
